var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.5H15.75V9C15.75 8.586 16.086 8.25 16.5 8.25H19.5C19.914 8.25 20.25 8.586 20.25 9V10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6C19.5 5.17125 18.8288 4.5 18 4.5C17.1712 4.5 16.5 5.17125 16.5 6C16.5 6.82875 17.1712 7.5 18 7.5C18.8288 7.5 19.5 6.82875 19.5 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3V12H22.5008L22.5 3H13.5ZM22.5 13.5H13.5C12.6727 13.5 12 12.8273 12 12V3C12 2.17275 12.6727 1.5 13.5 1.5H22.5C23.3273 1.5 24 2.17275 24 3V12C24 12.8273 23.3273 13.5 22.5 13.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5H9.75V19.5C9.75 18.225 8.775 17.25 7.5 17.25H4.5C3.225 17.25 2.25 18.225 2.25 19.5V22.5H0.75V19.5C0.75 17.4 2.4 15.75 4.5 15.75H7.5C9.6 15.75 11.25 17.4 11.25 19.5V22.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75C3.9 6.75 2.25 8.4 2.25 10.5C2.25 12.6 3.9 14.25 6 14.25C8.1 14.25 9.75 12.6 9.75 10.5C9.75 8.4 8.1 6.75 6 6.75ZM6 8.25C7.275 8.25 8.25 9.225 8.25 10.5C8.25 11.775 7.275 12.75 6 12.75C4.725 12.75 3.75 11.775 3.75 10.5C3.75 9.225 4.725 8.25 6 8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.fa4760ec92efb19c9c953ca0304a191b.svg";
export { ForwardRef as ReactComponent };